import { PivotField } from './pivot-dom-library.js?v4'

const COUNTRY = {
  regions: [
    {
      region: 'Arica y Parinacota',
      communes: ['Arica', 'Camarones', 'Putre', 'General Lagos'],
    },
    {
      region: 'Tarapacá',
      communes: [
        'Iquique',
        'Alto Hospicio',
        'Pozo Almonte',
        'Camiña',
        'Colchane',
        'Huara',
        'Pica',
      ],
    },
    {
      region: 'Antofagasta',
      communes: [
        'Antofagasta',
        'Mejillones',
        'Sierra Gorda',
        'Taltal',
        'Calama',
        'Ollagüe',
        'San Pedro de Atacama',
        'Tocopilla',
        'María Elena',
      ],
    },
    {
      region: 'Atacama',
      communes: [
        'Copiapó',
        'Caldera',
        'Tierra Amarilla',
        'Chañaral',
        'Diego de Almagro',
        'Vallenar',
        'Alto del Carmen',
        'Freirina',
        'Huasco',
      ],
    },
    {
      region: 'Coquimbo',
      communes: [
        'La Serena',
        'Coquimbo',
        'Andacollo',
        'La Higuera',
        'Paiguano',
        'Vicuña',
        'Illapel',
        'Canela',
        'Los Vilos',
        'Salamanca',
        'Ovalle',
        'Combarbalá',
        'Monte Patria',
        'Punitaqui',
        'Río Hurtado',
      ],
    },
    {
      region: 'Valparaíso',
      communes: [
        'Valparaíso',
        'Casablanca',
        'Concón',
        'Juan Fernández',
        'Puchuncaví',
        'Quintero',
        'Viña del Mar',
        'Isla de Pascua',
        'Los Andes',
        'Calle Larga',
        'Rinconada',
        'San Esteban',
        'La Ligua',
        'Cabildo',
        'Papudo',
        'Petorca',
        'Zapallar',
        'Quillota',
        'Calera',
        'Hijuelas',
        'La Cruz',
        'Nogales',
        'San Antonio',
        'Algarrobo',
        'Cartagena',
        'El Quisco',
        'El Tabo',
        'Santo Domingo',
        'San Felipe',
        'Catemu',
        'Llaillay',
        'Panquehue',
        'Putaendo',
        'Santa María',
        'Quilpué',
        'Limache',
        'Olmué',
        'Villa Alemana',
      ],
    },
    {
      region: 'Región del Libertador Gral. Bernardo O’Higgins',
      communes: [
        'Rancagua',
        'Codegua',
        'Coinco',
        'Coltauco',
        'Doñihue',
        'Graneros',
        'Las Cabras',
        'Machalí',
        'Malloa',
        'Mostazal',
        'Olivar',
        'Peumo',
        'Pichidegua',
        'Quinta de Tilcoco',
        'Rengo',
        'Requínoa',
        'San Vicente',
        'Pichilemu',
        'La Estrella',
        'Litueche',
        'Marchihue',
        'Navidad',
        'Paredones',
        'San Fernando',
        'Chépica',
        'Chimbarongo',
        'Lolol',
        'Nancagua',
        'Palmilla',
        'Peralillo',
        'Placilla',
        'Pumanque',
        'Santa Cruz',
      ],
    },
    {
      region: 'Región del Maule',
      communes: [
        'Talca',
        'Constitución',
        'Curepto',
        'Empedrado',
        'Maule',
        'Pelarco',
        'Pencahue',
        'Río Claro',
        'San Clemente',
        'San Rafael',
        'Cauquenes',
        'Chanco',
        'Pelluhue',
        'Curicó',
        'Hualañé',
        'Licantén',
        'Molina',
        'Rauco',
        'Romeral',
        'Sagrada Familia',
        'Teno',
        'Vichuquén',
        'Linares',
        'Colbún',
        'Longaví',
        'Parral',
        'Retiro',
        'San Javier',
        'Villa Alegre',
        'Yerbas Buenas',
      ],
    },
    {
      region: 'Región de Ñuble',
      communes: [
        'Cobquecura',
        'Coelemu',
        'Ninhue',
        'Portezuelo',
        'Quirihue',
        'Ránquil',
        'Treguaco',
        'Bulnes',
        'Chillán Viejo',
        'Chillán',
        'El Carmen',
        'Pemuco',
        'Pinto',
        'Quillón',
        'San Ignacio',
        'Yungay',
        'Coihueco',
        'Ñiquén',
        'San Carlos',
        'San Fabián',
        'San Nicolás',
      ],
    },
    {
      region: 'Región del Biobío',
      communes: [
        'Concepción',
        'Coronel',
        'Chiguayante',
        'Florida',
        'Hualqui',
        'Lota',
        'Penco',
        'San Pedro de la Paz',
        'Santa Juana',
        'Talcahuano',
        'Tomé',
        'Hualpén',
        'Lebu',
        'Arauco',
        'Cañete',
        'Contulmo',
        'Curanilahue',
        'Los Álamos',
        'Tirúa',
        'Los Ángeles',
        'Antuco',
        'Cabrero',
        'Laja',
        'Mulchén',
        'Nacimiento',
        'Negrete',
        'Quilaco',
        'Quilleco',
        'San Rosendo',
        'Santa Bárbara',
        'Tucapel',
        'Yumbel',
        'Alto Biobío',
      ],
    },
    {
      region: 'Región de la Araucanía',
      communes: [
        'Temuco',
        'Carahue',
        'Cunco',
        'Curarrehue',
        'Freire',
        'Galvarino',
        'Gorbea',
        'Lautaro',
        'Loncoche',
        'Melipeuco',
        'Nueva Imperial',
        'Padre las Casas',
        'Perquenco',
        'Pitrufquén',
        'Pucón',
        'Saavedra',
        'Teodoro Schmidt',
        'Toltén',
        'Vilcún',
        'Villarrica',
        'Cholchol',
        'Angol',
        'Collipulli',
        'Curacautín',
        'Ercilla',
        'Lonquimay',
        'Los Sauces',
        'Lumaco',
        'Purén',
        'Renaico',
        'Traiguén',
        'Victoria',
      ],
    },
    {
      region: 'Región de Los Ríos',
      communes: [
        'Valdivia',
        'Corral',
        'Lanco',
        'Los Lagos',
        'Máfil',
        'Mariquina',
        'Paillaco',
        'Panguipulli',
        'La Unión',
        'Futrono',
        'Lago Ranco',
        'Río Bueno',
      ],
    },
    {
      region: 'Región de Los Lagos',
      communes: [
        'Puerto Montt',
        'Calbuco',
        'Cochamó',
        'Fresia',
        'Frutillar',
        'Los Muermos',
        'Llanquihue',
        'Maullín',
        'Puerto Varas',
        'Castro',
        'Ancud',
        'Chonchi',
        'Curaco de Vélez',
        'Dalcahue',
        'Puqueldón',
        'Queilén',
        'Quellón',
        'Quemchi',
        'Quinchao',
        'Osorno',
        'Puerto Octay',
        'Purranque',
        'Puyehue',
        'Río Negro',
        'San Juan de la Costa',
        'San Pablo',
        'Chaitén',
        'Futaleufú',
        'Hualaihué',
        'Palena',
      ],
    },
    {
      region: 'Región Aisén del Gral. Carlos Ibáñez del Campo',
      communes: [
        'Coihaique',
        'Lago Verde',
        'Aisén',
        'Cisnes',
        'Guaitecas',
        'Cochrane',
        'O’Higgins',
        'Tortel',
        'Chile Chico',
        'Río Ibáñez',
      ],
    },
    {
      region: 'Región de Magallanes y de la Antártica Chilena',
      communes: [
        'Punta Arenas',
        'Laguna Blanca',
        'Río Verde',
        'San Gregorio',
        'Cabo de Hornos (Ex Navarino)',
        'Antártica',
        'Porvenir',
        'Primavera',
        'Timaukel',
        'Natales',
        'Torres del Paine',
      ],
    },
    {
      region: 'Región Metropolitana de Santiago',
      communes: [
        'Cerrillos',
        'Cerro Navia',
        'Conchalí',
        'El Bosque',
        'Estación Central',
        'Huechuraba',
        'Independencia',
        'La Cisterna',
        'La Florida',
        'La Granja',
        'La Pintana',
        'La Reina',
        'Las Condes',
        'Lo Barnechea',
        'Lo Espejo',
        'Lo Prado',
        'Macul',
        'Maipú',
        'Ñuñoa',
        'Pedro Aguirre Cerda',
        'Peñalolén',
        'Providencia',
        'Pudahuel',
        'Quilicura',
        'Quinta Normal',
        'Recoleta',
        'Renca',
        'Santiago',
        'San Joaquín',
        'San Miguel',
        'San Ramón',
        'Vitacura',
        'Puente Alto',
        'Pirque',
        'San José de Maipo',
        'Colina',
        'Lampa',
        'Tiltil',
        'San Bernardo',
        'Buin',
        'Calera de Tango',
        'Paine',
        'Melipilla',
        'Alhué',
        'Curacaví',
        'María Pinto',
        'San Pedro',
        'Talagante',
        'El Monte',
        'Isla de Maipo',
        'Padre Hurtado',
        'Peñaflor',
      ],
    },
  ],
}

class RegionSelector extends PivotField {
  static EVENTS = {
    CHANGED: 'communes-changed',
  }
  #communes = []
  type = 'select'

  get communes() {
    return this.#communes
  }

  connectedCallback() {
    super.connectedCallback()
    this.$input.innerHTML = `<option disabled selected value="">${
      this.label || 'Seleccione su región'
    }</option>
      ${COUNTRY.regions
        .map(r => `<option value="${r.region}">${r.region}</option>`)
        .join()}`

    const setter = value => {
      const region = COUNTRY.regions.find(rg => rg.region === value)
      if (!region) return
      this.#communes = region.communes
      this.dispatchEvent(
        new CustomEvent(RegionSelector.EVENTS.CHANGED, {
          bubbles: true,
          detail: this.#communes,
        })
      )
    }

    this.addEventListener('change', e => {
      const value = e.target.value
      setter(value)
    })

    this.setCustomReactivity({
      name: 'value',
      set: val => {
        this.$input.value = val
        setter(val)
      },
      get: () => this.$input.value,
    })
  }
}

customElements.define('pivot-region-selector', RegionSelector)

class CommuneSelector extends PivotField {
  type = 'select'

  constructor() {
    super()
    const regionReference = this['region-selector']
    const regionSelector = document.getElementById(regionReference)

    this.innerHTML = `<option disabled selected value="">${
      this.label || 'Seleccione su comuna'
    }</option>`

    regionSelector.addEventListener(
      RegionSelector.EVENTS.CHANGED,
      ({ detail }) => {
        this.$input.innerHTML = `<option value="" selected disabled>${
          this.label || 'Seleccione la comuna'
        }</option>`
        this.$input.innerHTML += detail.map(
          cm => `<option value="${cm}">${cm}</option>`
        )
        this.value = ''
      }
    )
  }

  connectedCallback() {
    super.connectedCallback()
    this.$input.innerHTML = `<option value="" selected disabled>${
      this.label || 'Seleccione la comuna'
    }</option>`
  }
}

customElements.define('pivot-commune-selector', CommuneSelector)

